
import { NavLink, useParams } from "react-router";

import { useReglementsByIdQuery } from "../../stores/OkOkStore";

import { useTrads } from "../../contexts/trads/useTrads";
import ReglementsEditForm from "../../components/Reglements/ReglementsEditForm";


function ReglementsEdit(){
    const params = useParams();

    const { data:reglement, error, isLoading } = useReglementsByIdQuery(params.id??"0");
    const {translate}=useTrads();
    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

        ) : reglement ? (
            <div>
                <nav>
                    <ul  className="nav nav-tabs">
                        <li className="nav-item"><NavLink className="nav-link" to={`/reglements/${reglement.id.toString()}/edit`}>{translate('btn_edit_reglement')}</NavLink></li>
                    </ul>
                </nav>
                <ReglementsEditForm  reglementParam={reglement} ></ReglementsEditForm>
            </div>

        ):null
    );
}
export default ReglementsEdit;